import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { ApiService } from '../../../../../utility/api.service'
import { ToastCtl } from '../../../../components/custom/toast/ToastCtl'

export const fetchBillings = createAsyncThunk('billings/fetchAll', async ({ filter = null, fields = null, offset = 0, limit = 250, sort }, { rejectWithValue }) => {
    const query = new URLSearchParams({
        filter: filter ? JSON.stringify(filter) : '',
        fields: fields ? JSON.stringify(fields) : '',
        offset,
        limit,
        sort: sort ? JSON.stringify(sort) : ''
    });
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/billings?${query}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { billings: Object.values(response.data), count: response.count }
})

export const fetchBilling = createAsyncThunk('billing/fetch', async ({ id }, { rejectWithValue }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/billing/${id}`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { billing: response.data.billing }
})

export const updateBilling = createAsyncThunk('billing/update', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.post(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/billing/${id}`, payload)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { billing: response.data.billing }
})

export const fetchMetas = createAsyncThunk('billing/meta', async ({ id, payload }, { rejectWithValue }) => {
    const response = await ApiService.get(`${process.env.REACT_APP_ASSETENERGY_APP_API}/assetapp/billings/meta`)
    if (!response.success) {
        return rejectWithValue(response.exception)
    }

    return { meta: response.data.meta }
})

const initialState = {
    billings: [],
    selectedBilling: null,
    loading: false,
    submitting: false,
    error: null,
    count: 0,
    meta: {}
}

const billingSlice = createSlice({
    name: 'billings',
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchBillings.pending]: (state) => {
            state.loading = true
        },
        [fetchBillings.fulfilled]: (state, { payload }) => {
            state.billings = payload.billings
            state.count = payload.count
            state.loading = false
        },
        [fetchBillings.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchMetas.pending]: (state) => {
            state.loading = true
        },
        [fetchMetas.fulfilled]: (state, { payload }) => {
            state.meta = payload.meta
            state.loading = false
        },
        [fetchMetas.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [fetchBilling.pending]: (state) => {
            state.loading = true
        },
        [fetchBilling.fulfilled]: (state, { payload }) => {
            state.selectedBilling = payload.billing
            state.loading = false
        },
        [fetchBilling.rejected]: (state, action) => {
            state.loading = false
            state.error = action
        },

        [updateBilling.pending]: (state) => {
            state.submitting = true
        },
        [updateBilling.fulfilled]: (state, { payload }) => {
            state.selectedBilling = payload.billing
            state.submitting = false
        },
        [updateBilling.rejected]: (state, action) => {
            state.submitting = false
            // NO error state because we show toast directly
        }
    }
})

export default billingSlice.reducer